import { useEffect } from "react";
import { captureFirstTouch } from "#/lib/analytics";

/**
 * Captures first-touch attribution once on initial mount. Mounted in `__root.tsx`
 * so it runs on every route, including the public landing (`/`) and referral
 * (`/r/:code`) routes where the first ad click typically lands. Write-once:
 * re-mounts and later navigations are no-ops.
 */
export function AttributionSync() {
	useEffect(() => {
		captureFirstTouch();
	}, []);

	return null;
}
